import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from 'hooks';
import { SaveButton } from 'views/components/core/buttons';
import { CustomDialog, DialogTitle, DialogContent, DialogActions } from 'views/components/core/dialog';

import './edit-columns.scss';

const DeleteColumn = ({ onClose }: { onClose: (action?: string) => void }) => {
    const { t } = useTranslation();

    return (
        <CustomDialog
            onClose={() => onClose()}
            aria-labelledby="delete-column"
            fullWidth
            scroll="paper"
            maxWidth="sm"
            open
        >
            <DialogTitle id="delete-column">
                {t('admin:deleteColumn')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        onClose();
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="remove-treatment-dialog-content">
                <span className="confirm-text pb-80">{t('admin:areYouSureToDeleteColumn')}</span>
            </DialogContent>

            <DialogActions className="actions-remove flex-end !k-pb-4 !k-pt-0">
                <SaveButton
                    onClick={() => {
                        onClose();
                    }}
                    text="cancel"
                />
                <SaveButton
                    id="remove-clumn-save-btn"
                    text="common:delete"
                    onClick={() => {
                        onClose('delete');
                    }}
                />
            </DialogActions>
        </CustomDialog>
    );
};

export default DeleteColumn;
